module.exports = __webpack_public_path__ + "static/img/link-bg-community.8880407.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/link-bg-community.png
// module id = kA00
// module chunks = 2